import { media } from 'Config/styled'
import styled, { css } from 'styled-components'

export const Title = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  font-size: 2rem;
  line-height: 2.5rem;
  margin-bottom: 1.5rem;
  ${media('lg')} {
    font-size: 20px;
    line-height: 10px;
    margin-bottom: 20px;
  }
`

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 100px;
  overflow-y: scroll;
  padding-top: 20px;

  ${props => {
    const tutorial = props.$tutorial ? '3rem' : '0px'
    const needsApproval = props.$needsApproval ? '138px' : '0px'
    return css`
      height: calc(100vh - 21rem - ${tutorial} - ${needsApproval});
    `
  }}

  ${media('lg')} {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    padding-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  ${media('xs')} {
    grid-template-columns: 1fr;
  }
`

export const TopbarContainer = styled.div`
  padding: 0rem 1.25rem;
`

export const ProviderCardLoadingContainer = styled.div`
  margin: 0 1.25rem 1.5rem;
`
